import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { map, delay } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MsalService } from '@azure/msal-angular';
import {
  AuthenticationResult,
  PublicClientApplication,
} from '@azure/msal-browser';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl = environment.apiUrl + 'Account/';
  baseUrl2 = environment.apiUrl + 'User/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private _location: Location,
    private msalService: MsalService
  ) {}

  confirm_registration(useridparam, codeparam) {
    return this.http.get(
      this.baseUrl + 'confirmemail?userId=' + useridparam + '&code=' + codeparam
    );
  }

  generateQRCodeUri() {
    return this.http.get<any>(this.baseUrl + 'generateQRCodeUri');
  }

  disable2fa() {
    return this.http.get(this.baseUrl + 'disable2fa');
  }

  verifyAuthApp(model: any) {
    return this.http.post(this.baseUrl + 'verifyAuthApp', model);
  }

  loginByTFA(model: any) {
    return this.http.post<any>(this.baseUrl + 'loginByTFA', model).pipe(
      map((response: any) => {
        const user = response;
        if (user) {
          localStorage.setItem('token', user.token);
          localStorage.setItem('originalToken', user.token);
          localStorage.setItem('index', user.index);
          localStorage.setItem('ulhid', user.ulhid);
        }
      })
    );
  }

  isAuthenticated() {
    const token = localStorage.getItem('token');
    if (token !== 'undefined' && token !== null && token !== '') {
      this.http
        .get(this.baseUrl + 'isAuthorized?url=' + this.router.url)
        .subscribe((data) => {
          if (!data) {
            this._location.back();
          }
        });
    } else {
      this.router.navigate(['/login']);
    }
  }

  isAllowed(id) {
    this.http.get(this.baseUrl + 'isAllowed?id=' + id).subscribe((data) => {
      if (!data) {
        this._location.back();
      }
    });
  }

  IsUserLoggedIn() {
    const token = localStorage.getItem('token');
    if (token !== 'undefined' && token !== null && token !== '') {
      this.http.get(this.baseUrl + 'isLoggedIn').subscribe(
        (data) => {
          if (data) {
            const userIndex = localStorage.getItem('index');
            this.router.navigate([userIndex]);
          }
        },
        (error) => {
          localStorage.clear();
        }
      );
    }
  }

  pageVisit() {
    return this.http.get(this.baseUrl + 'pagevisit?path=' + this.router.url);
  }

  getCurrentUser(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'getCurrentUser');
  }

  getSideMenu(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'getSideMenu');
  }

  getDashboardData(offset) {
    return this.http.get(this.baseUrl + 'getDashboardData?offset=' + offset);
  }

  pendingemailverification(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'pendingemailverification');
  }

  getLoginHistoryData(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'loginhistorydata');
  }

  getPageVisitedHistoryData(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'pagevisitdata');
  }

  updateSetting(model: any) {
    return this.http.post<any>(this.baseUrl + 'updateSetting', model);
  }

  getSettingData() {
    return this.http.get<any>(this.baseUrl + 'getSettingData');
  }

  getMenuList(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'getMenuList');
  }

  saveMenu(model: any) {
    return this.http.post(this.baseUrl + 'saveMenu', model);
  }

  deleteMenu(id) {
    return this.http.get(this.baseUrl + 'deleteMenu?Id=' + id);
  }

  getRoleList(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'getRoleList');
  }

  getRoleById(id) {
    return this.http.get<any>(this.baseUrl + 'getRoleById?Id=' + id);
  }

  saveRole(model: any) {
    return this.http.post(this.baseUrl + 'saveRole', model);
  }

  deleteRole(id) {
    return this.http.get(this.baseUrl + 'deleteRole?Id=' + id);
  }

  getUserList(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'getUserList');
  }

  saveUser(model: any) {
    return this.http.post(this.baseUrl + 'saveUser', model);
  }

  getProfileData(): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'getProfileData');
  }

  changePassword(model: any) {
    return this.http.post(this.baseUrl + 'changepassword', model);
  }

  updateProfile(model: any) {
    return this.http.post(this.baseUrl + 'updateprofile', model);
  }

  getProviders() {
    return this.http.get<any>(this.baseUrl + 'providers');
  }

  associateRegister(model: any) {
    return this.http.post<any>(this.baseUrl + 'associate', model);
  }

  setPassword(model: any) {
    return this.http.post(this.baseUrl + 'setpassword', model);
  }

  getAccount(id): Observable<any> {
    return this.http.get(this.baseUrl2 + id);
  }

  isLoggedIn(): boolean {
    return localStorage.getItem('token') != null;
  }

  register(model: any): Observable<any> {
    return this.http.post(this.baseUrl + 'register', model);
  }

  login(model: any): Observable<any> {
    return this.http.post(this.baseUrl + 'login', model);
  }

  authSuccess(res): Observable<any> {
    localStorage.setItem('token', res['token']);
    localStorage.setItem('originalToken', res['token']);
    localStorage.setItem('id', res['id']);
    localStorage.setItem('index', res['index']);
    localStorage.setItem('ulhid', res['ulhid']);
    localStorage.setItem('is2faenabled', res['is2faenabled']);

    return this.http.get(this.baseUrl2 + res['id'], { observe: 'response' });
  }

  loginMicrosoft() {
    localStorage.removeItem('pendingEmail');
    this.msalService.loginPopup().subscribe((res: AuthenticationResult) => {
      this.msalService.instance.setActiveAccount(res.account);
      this.msalService
        .acquireTokenSilent({
          account: this.msalService.instance.getActiveAccount(),
          scopes: [environment.SCOPES],
          prompt: 'select_account',
        })
        .subscribe((token) => {
          const username = this.msalService.instance.getActiveAccount().name; // Obtener el nombre de usuario

          this.http
            .post(this.baseUrl + 'registerMicrosoft', null, {
              // Incluir el nombre de usuario en la solicitud
              headers: {
                Authorization: `Bearer ${token.accessToken}`,
              },
            })
            .subscribe({
              next: (r) => {
                this.http
                  .post(this.baseUrl + 'loginMicrosoft', null, {
                    headers: {
                      Authorization: `Bearer ${token.accessToken}`,
                    },
                  })
                  .subscribe({
                    next: (ress) => {
                      localStorage.setItem('originalToken', ress['token']);
                      localStorage.setItem('token', ress['token']);
                      localStorage.setItem('id', ress['id']);
                      localStorage.setItem('index', ress['index']);
                      localStorage.setItem('ulhid', ress['ulhid']);
                      localStorage.setItem(
                        'is2faenabled',
                        ress['is2faenabled']
                      );
                      localStorage.setItem('username', username); // Guardar el nombre de usuario en el almacenamiento local
                      this.msalService.instance.loginRedirect();
                    },
                    error: (ee) => {
                      if (ee === 'AuthFailure.EnabledHandler.InProcess') {
                        localStorage.setItem(
                          'pendingEmail',
                          this.msalService.instance.getActiveAccount().username
                        );
                        this.router.navigate(['/pending-user']);
                      } else {
                        localStorage.clear();
                      }
                    },
                  });
              },
              error: (e) => {
                this.http
                  .post(this.baseUrl + 'loginMicrosoft', null, {
                    headers: {
                      Authorization: `Bearer ${token.accessToken}`,
                    },
                  })
                  .subscribe({
                    next: (ress) => {
                      localStorage.setItem('token', ress['token']);
                      localStorage.setItem('originalToken', ress['token']);
                      localStorage.setItem('id', ress['id']);
                      localStorage.setItem('index', ress['index']);
                      localStorage.setItem('ulhid', ress['ulhid']);
                      localStorage.setItem(
                        'is2faenabled',
                        ress['is2faenabled']
                      );
                      localStorage.setItem('username', username); // Guardar el nombre de usuario en el almacenamiento local
                      this.msalService.instance.loginRedirect();
                    },
                    error: (ee) => {
                      if (ee === 'AuthFailure.EnabledHandler.InProcess') {
                        localStorage.setItem(
                          'pendingEmail',
                          this.msalService.instance.getActiveAccount().username
                        );
                        this.router.navigate(['/pending-user']);
                      } else {
                        localStorage.clear();
                      }
                    },
                  });
              },
            });
        });
    });
  }

  msalInstance: PublicClientApplication = this.msalService
    .instance as PublicClientApplication;

  logout() {
    localStorage.removeItem('originalToken');
    localStorage.removeItem('token');
    localStorage.removeItem('id');
    localStorage.removeItem('index');
    localStorage.removeItem('ulhid');
    localStorage.removeItem('is2faenabled');
    localStorage.removeItem('username');
    localStorage.removeItem('companyLang');
    if (this.msalService.instance.getActiveAccount() != null) {
      this.msalService.logout();
      this.msalInstance['browserStorage'].clear();
      const currentAccount = this.msalService.instance.getActiveAccount();
      const logoutHint = currentAccount.idTokenClaims.login_hint;
      this.msalService.instance.logoutPopup({ logoutHint: logoutHint });
    }
    this.router.navigate(['/']);
  }

  getUserName() {
    return localStorage.getItem('username');
  }

  isSuperAdmin() {
    return this.http.get(this.baseUrl + 'isSuperAdmin', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  isAdmin() {
    return this.http.get(this.baseUrl + 'isAdmin', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('originalToken')}`,
      },
    });
  }

  updateUser(userId, newUser) {
    return this.http.post(this.baseUrl2 + `updateUser/${userId}`, newUser, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  activateUser(userId, companyId) {
    return this.http.post(this.baseUrl + `activateUser/${userId}`, companyId, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  forgotPassword(email) {
    return this.http.post(
      this.baseUrl + `forgotpassword`,
      {
        email: email,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
  }

  resetPassword(model) {
    return this.http.post(this.baseUrl + `resetpassword`, model, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
  }

  getBearerByIdCompany(idCompany) {
    return this.http.post(
      this.baseUrl + `getBearerByIdCompany?idCompany=${idCompany}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    );
  }

  switchAccount(data) {
    localStorage.setItem('token', data.token);
    localStorage.setItem('id', data.id);
    localStorage.setItem('index', data.index);
    localStorage.setItem('ulhid', data.ulhid);
    localStorage.setItem('is2faenabled', data.is2faenabled);
  }

  deleteUser(id) {
    return this.http.delete(this.baseUrl2 + `${id}`);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }
}
